


















import { createComponent } from "@vue/composition-api";
import {
  BaseToolHeader,
  BaseProgressBar
} from "@web-components";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

export default createComponent({
  components: {
    BaseToolHeader,
    BaseProgressBar
  },
  setup() {
    const dictionary = useDictionary();
    return {
      ...dictionary
    };
  }
});
